import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Home Brewing",
    date: "18 Nov, 2024",
    admin: "Admin",
    heading: "How to Brew the Perfect Cup of Coffee at Home",
    important: {
      content: "The perfect cup starts with fresh, high-quality coffee beans. Grind them just before brewing to unlock their full flavor potential.",
      intro: "Barista Pro"
    },
    paragraph: {
      para1: "Brewing a perfect cup of coffee at home is easier than you think! With the right equipment, beans, and technique, you can enjoy barista-quality coffee every day.",
      para2: "Whether you’re using a French press, pour-over, or espresso machine, we’ll guide you through the steps to create a delicious cup that suits your taste preferences.",
      para3: "Start with selecting your favorite coffee beans. Whether you prefer light, medium, or dark roast, the quality of the beans plays a crucial role in the final flavor. For optimal freshness, grind your beans just before brewing and use clean, filtered water to get the best taste.",
      para4: "Check out our gallery to see the coffee brewing process in action! From grinding the beans to brewing the perfect espresso, visual cues can help you master your coffee game. Whether you're a beginner or a seasoned coffee lover, these tips will help you improve your brewing technique."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Coffee", "Brewing", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "David William",
        date: "Aug 03, 2024",
        content: "I tried the French press method after reading this post, and it made such a difference! The coffee has never tasted so rich. Definitely going to keep this brewing method as my go-to.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Emily Rose",
            date: "Aug 07, 2024",
            content: "I'm so glad it worked for you! The French press really does bring out a rich flavor. Have you tried using freshly ground beans? That might make it even better!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Scott Taylor",
        date: "Aug 07, 2024",
        content: "Great tips! I’ve been using a pour-over method for years, but I learned so much from your post about adjusting grind size and water temperature. It’s made my morning brew so much better!"
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Latte Art",
    date: "20 Nov, 2024",
    admin: "Admin",
    heading: "The Art of Latte Art: Tips for Beginners",
    important: {
      content: "Latte art requires patience and practice, but with the right tools and techniques, you can create stunning designs. Start with steamed milk and a good espresso shot.",
      intro: "Latte Artist"
    },
    paragraph: {
      para1: "Latte art is the beautiful combination of espresso and steamed milk, creating designs that can transform your daily cup of coffee. With a little practice, you’ll be able to impress your friends with your skills!",
      para2: "To begin, you’ll need an espresso machine, a milk frother, and some high-quality coffee beans. Start by pulling a perfect espresso shot, as this will be the base of your design. Then, steam your milk to the right texture, aiming for a creamy consistency with microfoam.",
      para3: "When pouring, the key is to control your milk’s flow and pour steadily. Start by pouring into the center of your cup, then move your hand in a circular motion to create patterns. As you pour, you’ll start to see designs like hearts, rosettas, and tulips appear.",
      para4: "Check out our gallery to see step-by-step guides and tips on mastering latte art. From beginners’ basics to advanced techniques, these visuals will help you hone your skills and create your own signature designs."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Latte", "Guide", "Coffee"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Jessica Green",
        date: "Nov 05, 2024",
        content: "I followed your guide on steaming milk, and my lattes have never looked better! The heart design was my first successful attempt. Thanks for the tips!",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Oliver Black",
            date: "Nov 08, 2024",
            content: "That’s amazing! I remember my first successful heart. Have you tried pouring a rosetta yet? It’s a little tricky, but it’s so rewarding!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Linda Evans",
        date: "Nov 10, 2024",
        content: "I love how you broke down the technique into easy steps. I’ve been trying for weeks, but now I finally got the hang of it! My lattes look professional now."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Specialty Coffee",
    date: "25 Nov, 2024",
    admin: "Admin",
    heading: "Exploring the World of Specialty Coffee Beans",
    important: {
      content: "Specialty coffee beans are known for their unique flavors and high quality. Learn about different varieties and how to pick the best beans for your brewing needs.",
      intro: "Coffee Enthusiast"
    },
    paragraph: {
      para1: "Specialty coffee beans are a world of their own, offering a wide range of flavors and aromas that can elevate your coffee experience. From fruity and floral to nutty and chocolatey, each bean tells its own story.",
      para2: "The journey of specialty coffee begins at the farm, where the beans are grown in ideal conditions and harvested with care. These beans are then processed, roasted, and packaged to preserve their unique characteristics.",
      para3: "To choose the best specialty coffee beans, consider the origin, roast level, and flavor profile. Beans from Ethiopia, Colombia, and Costa Rica are particularly renowned for their distinct flavors. Opt for freshly roasted beans to get the most vibrant taste.",
      para4: "Check out our gallery to explore some of the finest specialty coffee beans, and see how different roasts and regions influence the flavor profiles. Whether you're a novice or an experienced coffee lover, this guide will help you select the right beans for your brew."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Beans", "Coffee", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Megan Parker",
        date: "Nov 12, 2024",
        content: "I had no idea that the origin of the beans makes such a big difference in flavor! I’m definitely going to try Ethiopian beans next. Great article!",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "John Davis",
            date: "Nov 15, 2024",
            content: "Ethiopian beans are fantastic! The fruity and floral notes really shine. Let me know how you like them when you try them out!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Chris White",
        date: "Nov 16, 2024",
        content: "This was so helpful! I never paid much attention to the roast level before. Now I’m experimenting with different roasts to find my perfect cup."
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Health & Coffee",
    date: "28 Nov, 2024",
    admin: "Admin",
    heading: "The Health Benefits of Drinking Coffee",
    important: {
      content: "Coffee is more than just a morning pick-me-up. Discover how this beloved beverage can offer numerous health benefits when consumed in moderation.",
      intro: "Health Advocate"
    },
    paragraph: {
      para1: "Coffee is often seen as a simple source of energy, but its benefits extend far beyond just waking you up. From boosting metabolism to reducing the risk of certain diseases, coffee is packed with health advantages.",
      para2: "Drinking coffee in moderation can improve brain function, enhancing memory, focus, and overall mental clarity. It has also been linked to a reduced risk of neurodegenerative diseases like Alzheimer's and Parkinson's.",
      para3: "Coffee is rich in antioxidants, which help protect your cells from damage and may lower your risk of certain cancers. It also plays a role in improving heart health by reducing the likelihood of stroke and lowering the risk of heart disease.",
      para4: "Check out our gallery for more insights into the health benefits of coffee. From improved athletic performance to better liver function, these visuals will help you understand how coffee can fit into a healthy lifestyle."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Health", "Coffee", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Lisa Simmons",
        date: "Nov 18, 2024",
        content: "I had no idea that coffee could help with Alzheimer’s! This really makes me appreciate my morning cup even more. Thanks for sharing!",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "David Clark",
            date: "Nov 20, 2024",
            content: "Exactly! I’m always learning new things about coffee. I also read that it helps improve physical performance too, which is awesome."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Rachel Lee",
        date: "Nov 22, 2024",
        content: "I’ve been drinking coffee for years, but I didn’t realize it had so many health benefits. I’m definitely drinking it more consciously now!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Coffee Beans",
    date: "02 Dec, 2024",
    admin: "Admin",
    heading: "How to Choose Coffee Beans for Your Brew Method",
    important: {
      content: "Choosing the right coffee beans for your preferred brew method is essential for achieving the perfect cup. Learn how different beans suit different brewing techniques.",
      intro: "Coffee Expert"
    },
    paragraph: {
      para1: "Choosing the right coffee beans for your brewing method can significantly enhance your coffee experience. Whether you prefer a rich espresso, a smooth pour-over, or a full-bodied French press brew, the beans you select will play a key role in the final flavor.",
      para2: "For espresso, opt for dark roast beans with a bold flavor profile. These beans undergo a longer roasting process, which intensifies their flavor and produces the perfect crema. On the other hand, lighter roasts are ideal for pour-over methods, as they allow the delicate flavors and aromas of the beans to shine.",
      para3: "If you love a French press brew, choose beans with a medium to dark roast, as this method extracts the full richness and body of the coffee. The coarser grind required for French press brewing ensures a smooth, thick coffee, perfect for savoring during a leisurely morning.",
      para4: "Check out our gallery for detailed tips on selecting the best beans for each brewing method. Visual guides and comparisons will help you decide which beans will work best for your specific brewing style, ensuring a flavorful cup every time."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Beans", "Brewing", "Coffee"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Nathan Green",
        date: "Dec 05, 2024",
        content: "I never knew the roast level had such an impact on the brew method! I always struggled with my espresso shots, but now I’ll be picking the right beans for it.",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Clara Johnson",
            date: "Dec 07, 2024",
            content: "Exactly! It’s all about the right roast and grind. I’ve been using a lighter roast for my pour-over, and the flavors have been so much more vibrant."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "James Anderson",
        date: "Dec 10, 2024",
        content: "This is so helpful! I always wondered why my French press coffee tasted too bitter. I’ll try a medium roast next time and see how it goes."
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Home Brewing",
    date: "10 Dec, 2024",
    admin: "Admin",
    heading: "The Best Brewing Equipment for Coffee Shop at Home",
    important: {
      content: "Creating a coffee shop experience at home starts with the right equipment. Discover the essential tools that every coffee enthusiast needs to brew barista-quality coffee.",
      intro: "Coffee Enthusiast"
    },
    paragraph: {
      para1: "Setting up a coffee shop at home requires more than just good beans. To replicate the quality and variety you’d expect at your favorite café, you’ll need the right brewing equipment. From grinders to espresso machines, the right tools can elevate your home brewing game.",
      para2: "A high-quality coffee grinder is essential for getting the best flavors from your beans. Burr grinders are preferable over blade grinders, as they provide a consistent grind size, ensuring a more even extraction.",
      para3: "For espresso lovers, an espresso machine is a must-have. Look for one with adjustable pressure and temperature settings to get the perfect shot every time. For drip coffee, a reliable coffee maker with precise water temperature control will make sure you get the most out of your beans.",
      para4: "Check out our gallery to see the must-have equipment for your home coffee setup. From grinders and espresso machines to pour-over kits and milk frothers, these tools will help you brew a café-quality cup every time."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Equipment", "Brewing", "Coffee"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Olivia Harris",
        date: "Dec 12, 2024",
        content: "I’ve been using a cheap grinder for months, and it made such a difference upgrading to a burr grinder. My coffee tastes so much better now!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Ryan Scott",
            date: "Dec 14, 2024",
            content: "Yes, a good grinder really transforms the taste. I also just upgraded to an espresso machine, and I feel like I’m drinking professional coffee at home now!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Sophia Martinez",
        date: "Dec 15, 2024",
        content: "I’m planning to get a pour-over kit soon! The process looks so relaxing, and I’ve heard it makes a really rich cup of coffee. Can’t wait to try it!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Espresso Brewing",
    date: "18 Dec, 2024",
    admin: "Admin",
    heading: "5 Tips for Brewing the Perfect Espresso",
    important: {
      content: "Brewing a perfect espresso requires precision and the right technique. Discover five essential tips to help you make barista-level espresso at home.",
      intro: "Espresso Expert"
    },
    paragraph: {
      para1: "Espresso is an art that combines technique, timing, and the right equipment. Whether you’re a beginner or an experienced coffee lover, these five tips will help you perfect your espresso-making skills.",
      para2: "The first tip is to always use fresh, high-quality beans. Opt for dark roasted beans with a rich flavor profile, and grind them just before brewing. The grind size should be fine, almost like powdered sugar, for the best extraction.",
      para3: "Another essential tip is to use the right water temperature. The ideal range for brewing espresso is between 195°F and 205°F. Water that’s too hot or too cold will affect the extraction, leading to bitter or weak coffee.",
      para4: "Check out our gallery for step-by-step visuals that showcase the espresso brewing process. From tamping the grounds to pulling the perfect shot, these tips and techniques will help you achieve a rich and balanced espresso every time."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Espresso", "Brewing", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Lucas Brown",
        date: "Dec 20, 2024",
        content: "I’ve been struggling to get the right shot, but after following your tips, my espresso has never tasted better! The grind size and water temperature make all the difference.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Maya Davis",
            date: "Dec 22, 2024",
            content: "I had the same issue with weak espresso! The water temp tip really helped me. Now I get a perfect shot every time!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Ethan White",
        date: "Dec 23, 2024",
        content: "I’ve always been intimidated by espresso, but your post gave me the confidence to try it. My first shot came out amazing! Can’t wait to experiment more."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Coffee Beans",
    date: "26 Dec, 2024",
    admin: "Admin",
    heading: "Cold Brew vs Iced Coffee: Which is Better",
    important: {
      content: "Cold brew and iced coffee are both popular ways to enjoy chilled coffee, but which one is right for you? Discover the key differences and benefits of each.",
      intro: "Coffee Enthusiast"
    },
    paragraph: {
      para1: "Cold brew and iced coffee are two refreshing ways to enjoy coffee, but they’re made in very different ways and offer distinct flavors. Understanding their differences can help you decide which one is best suited for your taste.",
      para2: "Cold brew coffee is made by steeping coarsely ground coffee beans in cold water for 12 to 24 hours. The result is a smooth, less acidic brew with a rich, concentrated flavor. It’s perfect for those who prefer a coffee that’s bold yet mellow and easy on the stomach.",
      para3: "Iced coffee, on the other hand, is brewed hot and then chilled. While it has a brighter, more acidic taste compared to cold brew, it’s also quicker to prepare. The process of pouring hot coffee over ice can dilute the flavor, but it’s a convenient option for those who want a quick and refreshing coffee break.",
      para4: "Check out our gallery to see the brewing process for both cold brew and iced coffee, and learn about the key differences in taste, preparation time, and overall coffee experience. Whether you’re after a slow-sipped, mellow brew or a quick, ice-cold pick-me-up, this guide will help you make the perfect choice."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Brewing", "Coffee", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Grace Foster",
        date: "Dec 28, 2024",
        content: "I’ve always been an iced coffee fan, but after trying cold brew, I’m hooked! It’s so smooth and less bitter. I’m definitely making the switch.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Liam Carter",
            date: "Dec 30, 2024",
            content: "I agree! Cold brew has such a mellow flavor. I like that it’s not as acidic as iced coffee, but I still love a good iced coffee for a quick caffeine boost."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Ava Johnson",
        date: "Dec 31, 2024",
        content: "I never knew there was such a big difference between the two! I’m going to try cold brew next time. It sounds like a game-changer for my coffee routine."
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Home Brewing",
    date: "05 Jan, 2025",
    admin: "Admin",
    heading: "Mastering the Art of Brewing Coffee at Home",
    important: {
      content: "Brewing coffee at home is an art that anyone can master with the right techniques and equipment. Learn how to make cafe-quality coffee from the comfort of your own kitchen.",
      intro: "Coffee Enthusiast"
    },
    paragraph: {
      para1: "Brewing your own coffee at home allows you to enjoy a cup that’s personalized to your taste preferences. With a few simple tools and techniques, you can achieve the perfect brew every time, just like your favorite barista.",
      para2: "Start with high-quality beans. Whether you prefer light, medium, or dark roast, the key is to use fresh beans that are ground just before brewing. The grind size will depend on your brewing method, so take note of whether you're using a French press, pour-over, or espresso machine.",
      para3: "Water temperature is another crucial factor. For the best extraction, use water that’s between 195°F and 205°F. Too hot or too cold, and the coffee will taste off. Ensure you’re also using filtered water for the cleanest taste possible.",
      para4: "Our gallery showcases the art of brewing coffee at home, from selecting the right beans to perfecting your brewing technique. Whether you're using a pour-over, French press, or automatic coffee maker, these steps will help you create a perfect cup every time."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Brewing", "Coffee", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Noah Clark",
        date: "Jan 10, 2025",
        content: "I’ve tried so many brewing methods, but your tips on water temperature really helped me perfect my French press coffee. It’s so much smoother now!",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Sophia Green",
            date: "Jan 12, 2025",
            content: "I’ve been using the pour-over method for years, and getting the water temperature right has made a huge difference. My coffee is more flavorful than ever!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Daniel Lee",
        date: "Jan 15, 2025",
        content: "I never realized how much the grind size matters until I read your post. Changing that made such a difference to my espresso shots!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Latte Art",
    date: "15 Jan, 2025",
    admin: "Admin",
    heading: "Beginner’s Guide to Crafting Stunning Latte Art",
    important: {
      content: "Latte art is an impressive skill that adds a personal touch to your coffee. Learn the basics of creating beautiful designs in your latte with our easy-to-follow guide.",
      intro: "Latte Art Enthusiast"
    },
    paragraph: {
      para1: "Crafting stunning latte art is easier than you think! With the right technique and a bit of practice, you can create beautiful patterns that will impress your friends and elevate your coffee experience.",
      para2: "Start with the basics: a good espresso and steamed milk. The key to great latte art is having smooth, velvety milk foam that can be poured in a controlled, steady stream. Start by mastering the classic heart and rosette designs, which are perfect for beginners.",
      para3: "Temperature is crucial for steaming milk. Heat it to about 150°F—too hot, and you’ll lose the texture; too cold, and it won’t froth properly. Once you’ve mastered steaming, the next step is pouring. Hold your cup at an angle, pour from a height, and then bring the pour closer to the surface to form your design.",
      para4: "Check out our gallery to see the transformation from a basic espresso to stunning latte art. Whether you're just starting or looking to improve your technique, these tips will help you create professional-looking designs at home."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Latte", "Guide", "Coffee"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Isabella White",
        date: "Jan 18, 2025",
        content: "I just tried the heart design and it actually turned out amazing! Your guide made it so much easier to understand. I’m excited to try more designs now!",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Ethan Black",
            date: "Jan 20, 2025",
            content: "That’s awesome! Once you’ve mastered the heart, try the rosette next. It’s a fun design and once you get the hang of it, it’s pretty easy to do."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Lily King",
        date: "Jan 22, 2025",
        content: "I’ve been trying to perfect my latte art for a while. Your tips on milk texture and pouring technique were a game-changer. I’m already seeing better results!"
      }
    ]
  },
  {
    id: 11,
    image: images.blog11,
    category: "Specialty Coffee",
    date: "20 Jan, 2025",
    admin: "Admin",
    heading: "A Journey Through Specialty Coffee Beans",
    important: {
      content: "Specialty coffee beans are known for their unique flavors and high-quality origins. Join us on a journey through the world of specialty coffee, from farm to cup.",
      intro: "Coffee Connoisseur"
    },
    paragraph: {
      para1: "Specialty coffee is more than just a drink—it’s an experience. The beans, grown in specific regions, are selected for their exceptional quality and unique flavor profiles. From rich, fruity notes to complex, earthy undertones, every specialty coffee offers a distinctive taste journey.",
      para2: "The journey begins at the farm. Specialty coffee beans are often grown in specific regions with ideal climates and altitudes. From Ethiopia’s highlands to Colombia’s lush landscapes, each coffee-growing region imparts a distinct flavor to the beans. The beans are harvested by hand to ensure only the best are selected.",
      para3: "Once the beans are harvested, they undergo a careful roasting process that brings out their best characteristics. Light roasts preserve the delicate flavors of the bean, while darker roasts offer a bolder, richer taste. The roasting process is an art, with each step crucial to achieving the perfect cup.",
      para4: "In our gallery, we showcase the various stages of specialty coffee beans, from the farms where they are grown to the final cup. Whether you’re a seasoned coffee drinker or a newcomer, exploring the journey of specialty coffee will deepen your appreciation for this beloved beverage."
    },
    gallery: [
      images.blog11Gallery1,
      images.blog11Gallery2
    ],
    tags: ["Beans", "Coffee", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog11Comment1,
        name: "Oliver Davis",
        date: "Jan 25, 2025",
        content: "I’ve always loved trying different coffees, but I never knew how much went into selecting the beans. Your post opened my eyes to the artistry behind it all!",
        replies: [
          {
            id: 1,
            image: images.blog11Comment2,
            name: "Amelia White",
            date: "Jan 27, 2025",
            content: "It’s amazing how much difference the origin of the beans can make! I’ve recently tried Ethiopian coffee, and it had such a fruity, vibrant flavor."
          }
        ]
      },
      {
        id: 2,
        image: images.blog11Comment3,
        name: "James Williams",
        date: "Jan 30, 2025",
        content: "This was such a great overview! I didn’t realize how much the roasting process affects the flavor. I’ll definitely pay more attention to where my coffee comes from."
      }
    ]
  },
  {
    id: 12,
    image: images.blog12,
    category: "Health & Coffee",
    date: "02 Feb, 2025",
    admin: "Admin",
    heading: "Discover the Health Benefits of Coffee Consumption",
    important: {
      content: "Coffee isn't just a delightful beverage; it’s packed with health benefits. Discover how drinking coffee in moderation can boost your energy and overall well-being.",
      intro: "Health Enthusiast"
    },
    paragraph: {
      para1: "Coffee is one of the most popular beverages worldwide, and for good reason. It’s not only an energizing pick-me-up, but it also offers several health benefits when consumed in moderation. From improving brain function to supporting physical performance, coffee has a lot more to offer than just its rich flavor.",
      para2: "One of the most notable benefits of coffee is its ability to enhance mental alertness. The caffeine in coffee stimulates the brain, improving focus, memory, and concentration. Studies have shown that regular coffee drinkers are less likely to develop cognitive decline as they age.",
      para3: "Beyond brain function, coffee is also packed with antioxidants, which help fight free radicals in the body. This makes coffee a powerful ally in reducing inflammation and protecting cells from damage. Additionally, drinking coffee has been linked to a reduced risk of certain diseases, including Parkinson's and type 2 diabetes.",
      para4: "In our gallery, we explore the numerous health benefits of coffee, from boosting energy to supporting longevity. Whether you enjoy it black, with milk, or in your favorite latte, coffee can be a healthy addition to your routine when consumed mindfully."
    },
    gallery: [
      images.blog12Gallery1,
      images.blog12Gallery2
    ],
    tags: ["Health", "Coffee", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog12Comment1,
        name: "Grace Martin",
        date: "Feb 05, 2025",
        content: "I had no idea that coffee could help prevent cognitive decline! I drink it every morning, and now I feel even better about it. Great insights!",
        replies: [
          {
            id: 1,
            image: images.blog12Comment2,
            name: "Luke Brown",
            date: "Feb 07, 2025",
            content: "Absolutely! I’ve heard that moderate coffee consumption can also help with physical performance. I’ve definitely felt more energized during my workouts."
          }
        ]
      },
      {
        id: 2,
        image: images.blog12Comment3,
        name: "Ava Johnson",
        date: "Feb 10, 2025",
        content: "I’m so glad I found this post. I’ve always loved coffee, and now I have even more reasons to drink it. Can’t wait to share this with my friends!"
      }
    ]
  }

];

export default blogs;